import { calendarClient } from "@calendar/calendarClient";
import { useSuspenseQuery } from "@tanstack/react-query";

export const calendarKeys = {
  range: (sessionKey: string, start: string, end: string) =>
    ["visits", "range", sessionKey, start, end] as const,
};

export const useScheduledVisits = (
  start: string,
  end: string,
  sessionKey: string,
) =>
  useSuspenseQuery({
    queryKey: calendarKeys.range(sessionKey, start, end),
    queryFn: () => calendarClient.range(start, end),
  });
